import React from "react";
import PropTypes from "prop-types";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { Link } from "react-router-dom";

const Breadcrumb = ({ config, extraBreadcrumbs }) => {
  const breadcrumbs = useReactRouterBreadcrumbs(config);

  return (
    <div className="breadcrumbs">
      {[...breadcrumbs, ...(extraBreadcrumbs ?? [])].map(
        (
          { match, breadcrumb, className, noLink, pathname, onClick, ...etc },
          index
        ) => {
          return (
            <React.Fragment key={match?.pathname}>
              {noLink && (
                <span className="breadcrumbs-item breadcrumbs-item--nolink">
                  {breadcrumb}
                </span>
              )}
              {!noLink && (
                <Link
                  to={pathname ?? match?.pathname}
                  className="breadcrumbs-item"
                  onClick={() => {
                    if (!match.route.props.onClick) {
                      return;
                    }

                    match.route.props.onClick();
                  }}
                >
                  {breadcrumb}
                </Link>
              )}
              <span className="breadcrumbs__separator">{">"}</span>
            </React.Fragment>
          );
        }
      )}
    </div>
  );
};

Breadcrumb.propTypes = {};

export default Breadcrumb;
